import { NoteIcon } from '@mm/icons';
import addSvg from 'assets/icons/add-grey.svg';
import classNames from 'classnames';
import moment from 'moment';
import React, { ChangeEvent, KeyboardEvent, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Dispatch } from 'redux';
import { PrimaryButton } from '../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import NotesCRUDActions from '@mm/state/actions/NotesCRUDActions';
import NoteModel from '@mm/state/model/NoteModel';
import { StoreState } from '@mm/state/store-interfaces';
import { AccordionItem } from '@mm/components';
import './Notes.pcss';
import { FileTextFilled } from '@ant-design/icons';
import TextInput from '../../../../../../common/components/TextInput';

type OuterProps = {
  notes: NoteModel[];
  contactId: number;
  onChange: (notes: NoteModel[]) => void;
  collapsedContactView?: boolean;
};

type InnerProps = ReturnType<typeof mapDispatchToProps>;

type Props = OuterProps & InnerProps;

const Notes = (props: Props) => {
  const { notes, onNoteAdd, onChange, collapsedContactView } = props;
  const [showAddForm, setAddShowForm] = useState(false);
  const [newNoteText, setNewNoteText] = useState('');
  const className = classNames('live-chat--contact-notes');

  const addNote = async () => {
    const noteText = newNoteText.trim();
    if (noteText) {
      const newNote = await onNoteAdd(noteText);
      onChange([newNote, ...notes]);
      setAddShowForm(false);
      setNewNoteText('');
    }
  };
  const handleKeyPress = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (!e.shiftKey && e.which === 13) {
      e.preventDefault();
      addNote();
    }
  };

  const handleSetNewNoteText = (e: ChangeEvent<HTMLTextAreaElement>) =>
    setNewNoteText(e.target.value);

  if (collapsedContactView) {
    return (
      <div className="live-chat--contact__header--collapsed">
        <FileTextFilled className="contact-details__header-icon" />
        <span className="live-chat--contact__content-number--collapsed">
          ({notes.length})
        </span>
      </div>
    );
  }
  return (
    <div className={className}>
      <AccordionItem
        icon={<FileTextFilled className="contact-details__header-icon" />}
        title="Notes"
        count={notes.length}
        className="contact-details__accordion-item"
        headingClassName="contact-details__accordion-item-heading"
        childrenWrapperClassName="contact-details__accordion-item-children-container"
      >
        <>
          <div className="live-chat--contact-section-title-container">
            <TextInput
              value={newNoteText}
              onKeyPress={handleKeyPress}
              onChange={handleSetNewNoteText}
              className="contact-details__note-input"
            />

            <PrimaryButton
              className="live-chat--contact-notes-add-btn"
              disabled={newNoteText.trim().length === 0}
              onClick={addNote}
            >
              Add
            </PrimaryButton>
          </div>

          {notes.map((note: NoteModel) => {
            return (
              <div key={note.id}>
                <div className="live-chat--contact__note">{note.body}</div>
                <div className="live-chat--contact__note-time">
                  {moment(note.createdAt).format('MMMM D')}
                </div>
              </div>
            );
          })}
        </>
      </AccordionItem>
    </div>
  );
};

const mapDispatchToProps = (
  dispatch: Dispatch<StoreState>,
  outerProps: OuterProps,
) => ({
  onNoteAdd: (noteText: string) =>
    dispatch(NotesCRUDActions.addNote(noteText, outerProps.contactId)),
});

const enhance = compose<InnerProps, OuterProps>(
  connect(null, mapDispatchToProps),
);

export default enhance(Notes);
